// Component Imports
import { FC } from 'react';
import LayoutNavbar from '../../../@layouts/components/vertical/Navbar';
import { VerticalNavbarContent } from './NavbarContent';
interface Props {
  sidebar?: boolean;
}

export const VerticalNavbar: FC<Props> = ({ sidebar }) => {
  return (
    <LayoutNavbar>
      <VerticalNavbarContent sidebar={sidebar} />
    </LayoutNavbar>
  );
};
